function QuoteIcon({ color = "#BE1622", className, style }) {
  return (
    <svg
      width={43}
      height={31}
      viewBox="0 0 43 31"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={{ color, ...style }}
    >
      <path
        d="M29.29 30.111l-2.813-2.343c1.562-2.266 2.734-4.18 3.515-5.743.86-1.796 1.485-3.085 1.875-3.867-1.094-.234-2.031-.586-2.812-1.055-1.25-.625-2.266-1.562-3.047-2.812-.938-1.328-1.406-3.086-1.406-5.273 0-1.875.585-3.594 1.757-5.157 1.797-2.5 4.22-3.75 7.266-3.75 2.734 0 5 .977 6.797 2.93C42.14 4.994 43 7.494 43 10.541c0 6.484-2.93 13.008-8.79 19.57h-4.92zm-24.259 0l-2.93-2.343c1.641-2.266 2.852-4.18 3.633-5.743.782-1.796 1.368-3.086 1.758-3.867C2.727 17.143.344 14.213.344 9.37c0-2.578.86-4.765 2.578-6.562C4.64 1.01 6.789.11 9.367.11c2.656 0 4.883.977 6.68 2.93 1.719 1.953 2.578 4.453 2.578 7.5 0 6.484-2.89 13.008-8.672 19.57H5.031z"
        fill="currentColor"
      />
    </svg>
  );
}

export default QuoteIcon;
